import { DeliveryType } from './enums'
import { NotificationType } from './NotificationTypes'

import { ITTL } from '../Interfaces'
import { ModelCommon } from '../ModelCommon'

const typeName = 'Notification'

export class Notification extends ModelCommon implements ITTL, NotificationType {
  // pk either user or self

  // dpk === NotificationSubscription
  // dsk === Incident or other grouping hash

  constructor({ ...ob }: NotificationType & ITTL & { pk?: string; sk?: string; id?: string }) {
    super(typeName, ob)
    this.name = `${ob.messageTitle}`
    this.ttl = ob.ttl
    this.incidentSk = ob.incidentSk
    this.MessageId = ob.MessageId
    this.messageTitle = ob.messageTitle
    this.messageContent = ob.messageContent
    this.messageHTML = ob.messageHTML
    this.deliveryType = ob.deliveryType
    this.emailDestinations = ob.emailDestinations
    this.smsDestinations = ob.smsDestinations
    this.timestamp = ob.timestamp
    this.success = ob.success
    this.acknowledged = ob.acknowledged
  }
  messageTitle: string | undefined
  messageContent: string | undefined
  messageHTML: string | undefined
  deliveryType: DeliveryType
  emailDestinations: string[]
  smsDestinations: string[]
  timestamp: number
  success: boolean
  acknowledged: boolean
  MessageId?: string | undefined
  incidentSk?: string | undefined

  ttl: number | undefined

  acknowledgeNotification() {
    this.acknowledged = true
  }
}
